import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { ItemListComponent } from '@shared/components';

import { TranslateService } from '@ngx-translate/core';
import { cloneDeep, each, find, map, remove } from 'lodash';

@Component({
  selector: 'app-select-filters-form-modal',
  templateUrl: './select-filters-form-modal.component.html',
  styleUrls: ['./select-filters-form-modal.component.scss'],
})
export class SelectFiltersFormModalComponent extends CustomFormComponent implements OnInit {

  @Input() options: any[];

  @Output() onSelected: EventEmitter<string[]> = new EventEmitter<string[]>();
  @ViewChild(ItemListComponent) itemListComponent: ItemListComponent;

  public selectedItems: any[] = [];
  public selectedItemsIDs: string[];
  public title: string = this.translate.instant('SHARED.Select_Column_Data');
  public subTitle: string = this.translate.instant('SHARED.Select_Column_Data_Subtitle');
  public saveButton: string = this.translate.instant('SHARED.Add_Filters');

  constructor(
    private popoverController: PopoverController,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    setTimeout(() => {
      let opts = map(this.options, (item) => item.id);
      each(opts, (item: any) => {
        const option = find(this.options, {id: item});
        option.checked = false;
        option.hidden = false;
      });
      each(this.selectedItems, (item: any) => {
        const option = find(this.options, {id: item});

        if (option) {
          option.checked = true;
          option.hidden = true;
          opts = remove(opts, (item) => item !== option.id);
        }
      });
    });
  }

  public onItemsSelected(): void {
    this.onSelected.emit(this.getSelectedItems());
  }

  public getSelectedItems(): any[] {
    this.selectedItems = cloneDeep(this.itemListComponent.getSelectedByID());
    this.selectedItemsIDs = map(this.selectedItems, 'id');
    return this.selectedItemsIDs;
  }

  public close() {
    this.popoverController.dismiss();
  }

  public applyForm() {
    this.popoverController.dismiss(this.selectedItemsIDs);
  }

}
